import React, { useEffect } from 'react';
import { setPageMeta } from '../utils/seo';

const Cookies = () => {
  useEffect(() => {
    setPageMeta({
      title: 'Política de Cookies',
      description: 'Política de cookies da Diamond Cars. Saiba como utilizamos cookies no nosso website.',
      path: '/cookies'
    });
  }, []);

  const lastUpdated = '14 de março de 2026';

  return (
    <div className="bg-gray-50 min-h-screen py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Cookies</h1>
          <p className="text-sm text-gray-500 mb-10">Última atualização: {lastUpdated}</p>

          <div className="space-y-8 text-gray-700 leading-relaxed">

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. O que são Cookies?</h2>
              <p>
                Cookies são pequenos ficheiros de texto que são armazenados no seu dispositivo (computador,
                tablet ou telemóvel) quando visita um website. Permitem que o site reconheça o seu dispositivo
                em visitas futuras e melhorem a sua experiência de navegação.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. Cookies que Utilizamos</h2>

              <div className="space-y-4">
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                    <h3 className="font-semibold text-gray-900">Cookies Essenciais</h3>
                    <span className="text-xs text-green-600 font-medium">Sempre ativos</span>
                  </div>
                  <div className="p-4">
                    <p className="text-sm text-gray-600 mb-3">
                      Necessários para o funcionamento básico do website. Sem estes cookies, o site não
                      funciona corretamente.
                    </p>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="text-left text-gray-500 border-b border-gray-100">
                          <th className="pb-2 pr-4">Cookie</th>
                          <th className="pb-2 pr-4">Finalidade</th>
                          <th className="pb-2">Duração</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-600">
                        <tr className="border-b border-gray-50">
                          <td className="py-2 pr-4 font-mono text-xs">session</td>
                          <td className="py-2 pr-4">Manter a sessão ativa</td>
                          <td className="py-2">Sessão</td>
                        </tr>
                        <tr>
                          <td className="py-2 pr-4 font-mono text-xs">firebase-auth</td>
                          <td className="py-2 pr-4">Autenticação e segurança</td>
                          <td className="py-2">1 ano</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                    <h3 className="font-semibold text-gray-900">Cookies de Desempenho</h3>
                    <span className="text-xs text-blue-600 font-medium">Analíticos</span>
                  </div>
                  <div className="p-4">
                    <p className="text-sm text-gray-600 mb-3">
                      Permitem-nos perceber como os visitantes interagem com o website, ajudando-nos
                      a melhorar a experiência de utilização. Toda a informação é anónima.
                    </p>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="text-left text-gray-500 border-b border-gray-100">
                          <th className="pb-2 pr-4">Cookie</th>
                          <th className="pb-2 pr-4">Finalidade</th>
                          <th className="pb-2">Duração</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-600">
                        <tr>
                          <td className="py-2 pr-4 font-mono text-xs">_ga</td>
                          <td className="py-2 pr-4">Google Analytics — estatísticas anónimas</td>
                          <td className="py-2">2 anos</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">3. Como Gerir os Cookies</h2>
              <p className="mb-4">
                Pode controlar e/ou eliminar cookies a qualquer momento através das definições do seu browser.
                Tenha em conta que desativar certos cookies pode afetar o funcionamento do website.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  { name: 'Google Chrome', url: 'https://support.google.com/chrome/answer/95647' },
                  { name: 'Mozilla Firefox', url: 'https://support.mozilla.org/pt-PT/kb/cookies-informacao-que-os-websites-armazenam-no-seu' },
                  { name: 'Safari', url: 'https://support.apple.com/pt-pt/guide/safari/sfri11471/mac' },
                  { name: 'Microsoft Edge', url: 'https://support.microsoft.com/pt-pt/microsoft-edge/eliminar-cookies-no-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09' },
                ].map(browser => (
                  <a
                    key={browser.name}
                    href={browser.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 p-3 border border-gray-200 rounded-lg hover:border-blue-400 hover:text-blue-600 transition text-sm"
                  >
                    <span className="font-medium">{browser.name}</span>
                    <span className="text-gray-400 text-xs ml-auto">→ Instruções</span>
                  </a>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Cookies de Terceiros</h2>
              <p>
                Este website não utiliza cookies de rastreamento publicitário de terceiros. Os únicos
                serviços externos que podem depositar cookies são o Firebase (autenticação/base de dados)
                e, se ativo, o Google Analytics para estatísticas anónimas de visitas.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. Contacto</h2>
              <p>
                Para qualquer questão sobre o uso de cookies neste website, contacte-nos em{' '}
                <a href="mailto:diamond.cars.rg@gmail.com" className="text-blue-600 hover:underline">
                  diamond.cars.rg@gmail.com
                </a>.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
